var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("QuickLook", {
    attrs: {
      horizontal: _vm.horizontal,
      yearlyValues: _vm.yearlyValues,
      horizon: _vm.horizon,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }